// components
import Modal from '@/components/Modal/Modal';

// styles
import styles from './ReportAProblemModal.module.scss';
interface ReportAProblemModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const ReportAProblemModal = (props: ReportAProblemModalProps) => {
  const {
    isOpen,
    onClose
  } = props;
  // @TODO build out this modal
  return <Modal isOpen={isOpen} onClose={onClose} className={styles.report_a_problem_modal} data-sentry-element="Modal" data-sentry-component="ReportAProblemModal" data-sentry-source-file="ReportAProblemModal.tsx">
      <h2>Report a Problem</h2>
    </Modal>;
};
export default ReportAProblemModal;